import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import LocationForm from '~/components/locationForm/locationForm';
import { locationValidationSchema } from '../../validation/location';

export const createLocationsMutation = gql`
  mutation createLocation($breweryId: Int!, $name: String!, $notes: String) {
    createLocation(breweryId: $breweryId, name: $name, notes: $notes) {
      id
      name
      notes
    }
  }
`;

export const LocationCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createLocationsMutation}>
      {(createLocation, { error }) => (
        <Formik
          initialValues={{
            type: 'GRAIN',
            measurementType: 'KG'
          }}
          validationSchema={locationValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newLocation = await createLocation({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['locations']
              });
              history.push(`/settings/locations?new=${newLocation.data.createLocation.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={LocationForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(LocationCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/locationCreate/locationCreate.jsx